import { haveRoutePerms } from './auth';
export function handleRoute(enterpriseMarket, routes) {
  const newRoute = [];
  const SellerNewRoute = [];
  const bool = window.sessionStorage.getItem('isAdmin')

  if (enterpriseMarket) {
    routes.map((item) => {
      if (
        item.meta &&
        item.meta.role != undefined &&
        item.meta.role == 'seller') {
        if (item.children && item.children.length > 0) {
          item.children = handleRoute(enterpriseMarket, item.children);
        }
        if (item.props && item.children.length == 0) {
          return;
        }
        if (item.meta && item.meta.perms) {
          if (haveRoutePerms(item.meta.perms)) {
            SellerNewRoute.push(item);
          }
        } else {
          SellerNewRoute.push(item);
        }
      } else {
        if (
          item.meta &&
            item.meta.role != undefined &&
            item.meta.role != 'market'
        ) {
          return;
        }
        if (item.children && item.children.length > 0) {
          item.children = handleRoute(enterpriseMarket, item.children);
        }
        if (item.props && item.children.length == 0) {
          return;
        }
        if (item.meta && item.meta.perms) {
          if (haveRoutePerms(item.meta.perms)) {
            newRoute.push(item);
          }
        } else {
          newRoute.push(item);
        }
      }
    });
    if (bool == 'false') {
      return SellerNewRoute
    } else {
      return newRoute
    }
  }

  routes.map((item) => {
    if (item.meta && (item.meta.role == 'market' || item.meta.role == 'seller')) {
      return;
    }
    if (item.children && item.children.length > 0) {
      item.children = handleRoute(enterpriseMarket, item.children);
    }
    if (item.props && item.children.length == 0) {
      return;
    }
    if (item.meta && item.meta.perms) {
      if (haveRoutePerms(item.meta.perms)) {
        newRoute.push(item);
      }
    } else {
      newRoute.push(item);
    }
  });
  return newRoute;

}

export function handleRegion(regions) {
  if (!regions) {
    return [];
  }
  const optionMaps = {};
  regions.map((item) => {
    if (optionMaps[item.envName]) {
      optionMaps[item.envName].push({
        label: item.regionAlias,
        value: item.regionID
      });
    } else {
      optionMaps[item.envName] = [
        { label: item.regionAlias, value: item.regionID }
      ];
    }
  });
  const options = [];
  for (const key in optionMaps) {
    options.push({ label: key, options: optionMaps[key] });
  }
  return options;
}

var defaultTitle = 'AI智能体市场';
var defaultDescription = 'AI智能体市场是一个汇聚了各类开源软件的应用市场，在这里你可以发现和使用各类云原生应用。主要包含了各类应用的 Helm Chart、 RAM 模版以及二进制文件，同时还支持信创应用。对于 Helm 应用，优化了镜像拉取的问题，使其可以快速部署；对于 RAM 模版和信创应用，可以在 Rainbond 中一键安装和升级。';
var defaultKeywords = 'AI智能体市场,应用商店,云原生应用商店,行业云应用商店,自动交付,SaaS服务,云边协同,ISV厂商应用商店,Rainstore,解决方案,Helm 仓库,Helm Repository,Helm 商店,Helm 市场,Helm Hub,Helm 国内源,Helm 加速';

export function setDefaultWebInfo(title, description, keywords) {
  if (title) {
    defaultTitle = title;
  }
  if (description) {
    defaultDescription = description;
  }
  if (keywords) {
    defaultKeywords = keywords;
  }
  setWebInfo();
}

export function setWebInfo(title, description, keywords) {
  document.title = title || defaultTitle;
  const kdom = document.querySelector('meta[name="keywords"]');
  if (kdom) {
    kdom.setAttribute('content', keywords || defaultKeywords);
  }
  const ddom = document.querySelector('meta[name="description"]');
  if (ddom) {
    ddom.setAttribute('content', description || defaultDescription);
  }
  return;
}



// WEBPACK FOOTER //
// ./src/utils/common.js